module.exports = __webpack_public_path__ + "img/extension.afcc12e5.gif";